import { defineMessages } from 'react-intl';

export const personalizationSharedMessages = defineMessages({
  requestDemoSignup: {
    defaultMessage: 'Request a 1:1 demo with a Heidi expert',
    id: 'R38Bm6DGUZ',
    description:
      'Checkbox label to opt in to requesting a 1:1 demo with a Heidi expert (request-demo variant)',
  },
  bookDemoWebinarSignup: {
    defaultMessage: 'Book a Demo / Webinar',
    id: '81x4T78dsb',
    description:
      'Checkbox label for the combined book-a-demo / webinar opt-in (webinar variant)',
  },
  webinarTimeslotLabel: {
    defaultMessage: 'Select a session time',
    id: 'fi+6o6vvBS',
    description: 'Label for the webinar timeslot picker when opted in',
  },
  webinarTimeslotLoading: {
    defaultMessage: 'Loading sessions...',
    id: 'WKZTefMbRS',
    description: 'Placeholder while webinar session timeslots are loading',
  },
  webinarTimeslotPlaceholder: {
    defaultMessage: 'Select a session',
    id: '+iEPvKWmMT',
    description: 'Placeholder for the webinar timeslot select when timeslots are loaded',
  },
  webinarBookedOutFallback: {
    defaultMessage:
      "All upcoming sessions are currently booked out. Leave your number and we'll reach out to arrange one.",
    id: 'ZGtovpkCmL',
    description:
      'Message shown above the phone fallback when no webinar sessions are available',
  },
  phoneNumber: {
    defaultMessage: 'Phone number',
    id: 'e4ZVUKkMw0',
    description: 'Label for the required phone number field on request-demo onboarding',
  },
  phoneNumberPlaceholder: {
    defaultMessage: 'Enter a phone number',
    id: 'IFfPQaFN8s',
    description: 'Placeholder for the phone number input on request-demo onboarding',
  },
  invalidPhoneNumber: {
    defaultMessage: 'Please enter a valid phone number',
    id: 'ACHcOViqHM',
    description: 'Validation error when the phone number format is invalid',
  },
  demoReasonLabel: {
    defaultMessage: 'Reason for demo',
    id: 'isXZuqbaOK',
    description: 'Label for the free-text reason field on request-demo onboarding',
  },
  demoReasonPlaceholder: {
    defaultMessage: 'e.g. Exploring for my practice, evaluating AI tools...',
    id: 'pAGIs3es7p',
    description: 'Placeholder for the demo reason input on request-demo onboarding',
  },
  attachFiles: {
    defaultMessage: 'Attach files',
    id: 'lyDE+itQ6w',
    description: 'Aria label for the attach example notes button during onboarding',
  },
  uploadExampleNotes: {
    defaultMessage: 'Upload example notes',
    id: 'uIk6L7qUFa',
    description: 'Tooltip when the user can still attach more example note files',
  },
  maximumFilesReached: {
    defaultMessage: 'Maximum 5 files reached',
    id: 'sfCdJCfzGD',
    description: 'Tooltip when the onboarding file upload limit is reached',
  },
  selectClinician: {
    defaultMessage: 'Select a clinician type',
    id: 'WzA/fnCeYm',
    description: 'Placeholder for the clinician type combobox during onboarding',
  },
  searchClinicianTypes: {
    defaultMessage: 'Search clinician types...',
    id: 'DmslAVBunk',
    description: 'Search placeholder in the clinician type combobox during onboarding',
  },
  noSpecialtyFound: {
    defaultMessage: 'No specialty found.',
    id: 'XufENNUmS/',
    description: 'Empty state when clinician type search returns no matches',
  },
  other: {
    defaultMessage: 'Other',
    id: '3vX/qxsfwR',
    description: 'Fallback clinician type when the user enters a custom specialty',
  },
  selectCountry: {
    defaultMessage: 'Select a country...',
    id: 'e4xmmFtu1H',
    description: 'Placeholder for the country combobox during onboarding',
  },
  searchForCountry: {
    defaultMessage: 'Search for a country...',
    id: 'c8GQj4seSy',
    description: 'Search placeholder in the country combobox during onboarding',
  },
  noCountryFound: {
    defaultMessage: 'No country found.',
    id: 'pLjSt5oo5w',
    description: 'Empty state when country search returns no matches',
  },
  selectCountryFirst: {
    defaultMessage: 'Set country in settings first',
    id: '8NFOOmvt2u',
    description:
      'Disabled placeholder on jurisdiction select when no country is selected yet',
  },
  noRegionsAvailable: {
    defaultMessage: 'No states/regions available',
    id: 'i72DOWZ8lc',
    description:
      'Disabled placeholder on jurisdiction select when the country has no subdivisions',
  },
  noResultsFound: {
    defaultMessage: 'No results found',
    id: 'LcI3Ban+Pl',
    description: 'Empty state when jurisdiction search returns no matches',
  },
  comboboxSearchPlaceholder: {
    defaultMessage: 'Search...',
    id: 'EuJxN7WgIL',
    description: 'Default search placeholder for onboarding combobox dropdowns',
  },
  comboboxSelectItem: {
    defaultMessage: 'Select an item...',
    id: '2nkBciUAqe',
    description: 'Default placeholder for onboarding combobox when nothing is selected',
  },
  comboboxUnselectItem: {
    defaultMessage: 'Unselect item',
    id: 'lyQlyQRlzW',
    description: 'Option to clear the current selection in an onboarding combobox',
  },
  heidiProAlt: {
    defaultMessage: 'Heidi Pro',
    id: 'GdvL1+Ln9J',
    description: 'Alt text for the Heidi Pro badge on pro-only combobox items',
  },
});
